import moment from "moment";

export default function (value) {
    let date = moment(value, 'DD/MM/YYYY', true).format('YYYY-MM-DD')
    let age = moment().diff(date, 'years', false);
    return age >= 18
}
